import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CuentaService {

  constructor(private _http: HttpClient) { }

  getUsuario(idUsuario: any): Observable<any> {
    //deberia ser tipo number
    const url = environment.URL_BASE + 'cliente/get?id=' + idUsuario;
    return this._http.get(url);
  }

  getCountry() {
    const url = environment.URL_BASE + 'country/all';
    return this._http.get(url);
  }

  postGuardarUsuario(usuario: any) {
    const url = environment.URL_BASE + 'cliente/save';
    return this._http.post(url, usuario);
  }

  postGuardarFoto(json: any) {
    const url = environment.URL_BASE + 'cliente/savePicture';
    return this._http.post(url, json);
  }

  requestObtenerSupervisor(idCliente){
    const url = environment.URL_BASE + 'cliente/getSupervisor?idCliente='+idCliente;
    return this._http.get(url);
  }
  // getRecuperarFoto(idUsuario: string) {
  //   const url = environment.URL_BASE + 'cliente/getpicture?id=' + idUsuario;
  //   return this._http.get(url);
  // }
}
